/**
 * @author Owais Liaquat Ali
 * @datetime Aug, 10th 2023
 * @description: This class is for date time parsed.
 */
import { Pipe, PipeTransform } from '@angular/core';
import { convertParseDateTime } from 'src/app/shared/utils/utility.service';

@Pipe({
  name: 'parsedTime',
})
export class ParsedTimePipe implements PipeTransform {
  transform(
    time: string,
    currentFormat:
      | 'hh:mm a'
      | 'HH:mm'
      | 'yyyy-MM-dd'
      | 'yyyy/MM/dd'
      | "EEE, MMM do, yyyy 'at' h:mm a"
      | 'yyyy, MM, dd h:mm a'
      | 't'
      | 'yyyy/MM/dd hh:mm a',
    parseFormat:
      | 'hh:mm a'
      | 'HH:mm'
      | 'yyyy-MM-dd'
      | 'yyyy/MM/dd'
      | "EEE, MMM do, yyyy 'at' h:mm a"
      | 'yyyy, MM, dd h:mm a'
      | 't'
      | 'yyyy/MM/dd hh:mm a'
      | 'MMM d, yyyy h:mma'
  ): any {
    if (!time) return null;

    return convertParseDateTime(String(time), currentFormat, parseFormat);
  }
}
